import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { AplicacionRecipienteService } from "../../../generated/grpc/aplicaciones_pb";
import { grpcAplicacionRecipienteDatabase } from "../database/GrpcAplicacionRecipienteDatabase";
import { AplicacionRecipienteResponse } from "../response/AplicacionRecipienteResponse";
import { fx_createAplicacionRecipienteGrpcService } from "./AplicacionRecipienteGrpcService";

/** Baja de un recipiente propio del cliente. Un recipiente **global** no se
 *  puede eliminar: el server responde `InvalidArgument` y la UI no ofrece el
 *  botón (`fx_esRecipienteGlobal`). */
export class AplicacionRecipienteDeleteGrpcService
  implements IDeleteService<AplicacionRecipienteResponse>
{
  async deleteAsync(item: AplicacionRecipienteResponse): Promise<void> {
    const client = createClient(
      AplicacionRecipienteService,
      grpcTransportProvider.get(),
    );

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcAplicacionRecipienteDatabase.deleteOneAsync(item.id);
    fx_createAplicacionRecipienteGrpcService(item.clienteId).clearCache();
  }
}

/** Instancia única del servicio de baja de recipientes. */
export const aplicacionRecipienteDeleteGrpcService =
  new AplicacionRecipienteDeleteGrpcService();
